import { render, staticRenderFns } from "./ClientProfileComponent.vue?vue&type=template&id=0dedaf49"
import script from "./ClientProfileComponent.vue?vue&type=script&lang=js"
export * from "./ClientProfileComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports